
import { QueryClient } from "react-query";
import { RightFillIcon } from "@t8891/icon";
import cx from "classnames";
import React, { memo } from "react";
import styles from "./Index.module.less";
import AdBySelfRefresh from "@Components/ad/AdBySelfRefresh";
import { Common } from "@Api";

import { host } from "@Services/url";
import OverflowTooltip from "@Components/overflowTooltip";

const { postInitialCollect } = Common;

interface IProps {
  dataObj: {
    ads?: {
      adclick: string;
      appLink: string;
      id: number;
      image: string;
      subscript: number;
      tag: string;
      title: string;
      type: number;
    };
    /* 车款ID */
    kindId?: number;
    /* 图片 */
    thumb?: string;
    /* 厂牌名 */
    brandName?: string;
    /* 车款名 */
    kindName?: string;
    /* 价格 */
    price?: string;
    /* 月销量等其他文案 */
    modelNum?: string;
    /* 判断是否可以一键询价 */
    inquiry?: number;
    /* 厂牌ID */
    brandId?: number;
    /* 判断是否有配备 */
    specLink?: string;
    /* 判断是否有优惠礼包、价格 */
    maxDiscountPrice?: string;
    /* 图片的href */
    picHref?: string;
    /* 一键询价的href */
    btnHref?: string;
    /* seo 图片alt */
    alt?: string;
    /* 配备讲解 */
    equipMovieId?: number;
  };
  className?: string;
  onClickPic?: () => any;
  onClickBtn?: () => any;
}

const CarItem = (props: IProps) => {
  const { dataObj, onClickPic, onClickBtn, className } = props;

  return (
    <section className={styles["list-container"]}>
      {!!dataObj?.ads && <div className={styles["ads-icon"]}>贊助</div>}
      <div
        className={cx(styles["list-item"])}
        key={dataObj.kindId}
        style={{ padding: !dataObj.inquiry && !dataObj.inquiry ? "8px 16px" : "8px 16px 19px 16px" }}
      >
        <a
          href={`/kind-summary/${dataObj.kindId}`}
          target='_blank'
          className={styles["item-msg"]}
          onClick={() => onClickPic && onClickPic()}
        >
          <img
            src={dataObj.thumb}
            className={styles["item-img"]}
            alt={`${dataObj.alt ? dataObj.alt : `${dataObj.brandName || ""} ${dataObj.kindName || ""}`}`}
          />
          <OverflowTooltip tooltipTitle={`${dataObj.brandName || ""} ${dataObj.kindName || ""}`}>
            <p className={styles["item-brand"]}>{`${dataObj.brandName || ""} ${dataObj.kindName || ""}`}</p>
          </OverflowTooltip>

          {dataObj.price && <p className={styles["item-price"]}>{dataObj.price}</p>}
          {dataObj.modelNum && <p className={styles["item-results"]}>{dataObj.modelNum}</p>}
        </a>
        <div className={styles["item-btn"]}>
          {dataObj.inquiry !== 0 && !!dataObj.btnHref && (
            <a
              href={dataObj.btnHref}
              target='_blank'
              className={cx(className, styles["btn-ask"])}
              onClick={() => {
                onClickBtn && onClickBtn();
                dataObj.ads && postInitialCollect(dataObj.ads, "click", "");
              }}
            >
              一鍵詢價
            </a>
          )}

          {dataObj.equipMovieId && dataObj.equipMovieId !== 0 ? (
            <a href={`${host.c}/equip/shorts/${dataObj.equipMovieId}`} className={styles["btn-config"]}>
              <span className={styles["btn-icon"]}>
                <RightFillIcon size={12} fill={"#333333"} />
              </span>
              配備詳解
            </a>
          ) : (
            dataObj.specLink && (
              <a href={dataObj.specLink} className={styles["btn-config"]}>
                配備
              </a>
            )
          )}
        </div>

        {dataObj.maxDiscountPrice && dataObj.maxDiscountPrice !== "" && (
          <div className={styles["item-bag"]}>
            <p className={styles["bag-title"]}>最高優惠</p>
            <p className={styles["bag-price"]}>禮包{dataObj.maxDiscountPrice}</p>
          </div>
        )}

        {dataObj.ads && (
          <AdBySelfRefresh
            data={dataObj.ads}
            first={true}
            refresh={() => postInitialCollect(dataObj.ads, "show", "")}
            styles={{ display: "inline-block" }}
          />
        )}
        {dataObj.ads && dataObj.ads.tag !== "" && <span className={styles["item-tag"]}>{dataObj.ads.tag}</span>}
      </div>
    </section>
  );
};

export default memo(CarItem);
